// extracted by mini-css-extract-plugin
module.exports = {"title":"FootprintsContainer_title__1FfWf","container":"FootprintsContainer_container__pegg2"};